<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-md-9">
                    <div class="mt-2 mb-2">
                        <strong>Master Document</strong>
                    </div>
                </div>
                <div class="col-md-3">
                    <goback></goback>
                </div>
            </div>
            <form class="master-document-form mb-3" @submit.prevent="uploadDocument">
                <div class="row">
                    <div class="col-md-6 form-group">
                        <label>Upload Document</label>
                        <input ref="fileInput" class="form-control" type="file" accept="application/pdf,.pdf"
                            @change="onFileChange" />
                    </div>
                    <div class="col-md-1 form-group">
                        <label>&nbsp;</label>
                        <button type="submit" class="btn btn-primary btn-block"
                            :disabled="isUploading || !selectedFile">
                            {{ isUploading ? "Uploading..." : "Upload" }}
                        </button>
                    </div>
                </div>
            </form>
            <div class="table-responsive">
                <table class="table table-bordered master-document-table" v-if="masterDocument">
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th>Size</th>
                            <th>Version</th>
                            <th>Created At</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ masterDocument.file_name }}</td>
                            <td>{{ formatSize(masterDocument.size_bytes) }}</td>
                            <td>{{ masterDocument.version }}</td>
                            <td>{{ formatDateTime(masterDocument.created_at) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else-if="!isLoading" class="text-center">No master document found</div>
            </div>
        </div>
    </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "@/assets/mixins/common.js";

export default {
    mixins: [commonMixins],
    created: function () {
        this.getMasterDocument();
    },
    data: function () {
        return {
            isLoading: false,
            isUploading: false,
            masterDocumentApi: "/frontend/esign/master-document",
            uploadDocumentApi: "/frontend/esign/master-document/upload",
            masterDocument: null,
            selectedFile: null
        };
    },
    methods: {
        getMasterDocument: function () {
            this.isLoading = true;
            var myself = this;
            http.post(this.masterDocumentApi, {}, function (error, response) {
                console.log("Master Document", response);
                if (!error && response && response.status === "success" && response.data) {
                    myself.masterDocument = response.data;
                } else {
                    myself.masterDocument = null;
                }
                myself.isLoading = false;
            });
        },
        onFileChange: function (event) {
            var files = event.target.files;
            this.selectedFile = files && files.length ? files[0] : null;
        },
        uploadDocument: function () {
            if (!this.selectedFile) {
                this.$toastr.error("Please select a file", "", {});
                return;
            }
            var formData = new FormData();
            formData.append("file", this.selectedFile);
            this.isUploading = true;
            var myself = this;
            http.post(this.uploadDocumentApi, formData, function (error, response) {
                console.log("Upload Master Document response: ", response);
                myself.isUploading = false;
                if (!error && response && response.status === "success") {
                    myself.$toastr.success("Document uploaded successfully!", "", {});
                    myself.selectedFile = null;
                    myself.$refs.fileInput.value = "";
                    myself.getMasterDocument();
                } else {
                    var message = (response && (response.message || response.status)) || "Failed to upload document";
                    myself.$toastr.error(message, "", {});
                }
            });
        },
        formatSize: function (bytes) {
            var size = Number(bytes) || 0;
            if (size >= 1024 * 1024) {
                return (size / (1024 * 1024)).toFixed(2) + " MB";
            }
            if (size >= 1024) {
                return (size / 1024).toFixed(2) + " KB";
            }
            return size + " B";
        },
        formatDateTime: function (value) {
            if (!value) {
                return "-";
            }
            var date = new Date(value);
            return isNaN(date.getTime()) ? value : date.toLocaleString();
        }
    }
};
</script>
<style>
.master-document-form label,
.master-document-form .form-control,
.master-document-form .btn {
    font-size: 12px;
}

.master-document-form .form-control {
    height: 30px;
    padding: 2px 4px;
    line-height: 1.5;
}

.master-document-form .btn {
    padding: 4px 8px;
}

.master-document-table {
    font-size: 13px;
}

.master-document-table th {
    background: #d8e2f2;
    color: #555;
    text-align: center;
    vertical-align: middle !important;
}

.master-document-table td {
    text-align: center;
    vertical-align: middle !important;
    padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/upload-masterpage.vue